import { CheckIcon, InfoIcon } from '@phosphor-icons/react';
import {
  Button,
  Cell,
  Column,
  Popover,
  Row,
  Table,
  TableBody,
  TableHeader,
} from '@skupreme/shared/ui';
import type { InventoryLot } from '../../lib/inventory';
import { DateFormat, DateUtility } from '@utility/date';

/** How an alias's stock splits across the WMS lots, opened from the row. */
export function LotsPopover({ lots }: { lots: InventoryLot[] }) {
  return (
    <Popover
      aria-label="Lots"
      placement="bottom start"
      className="sk:w-125 sk:max-w-[90vw] sk:p-3"
      trigger={
        <Button variant="ghost" size="sm" className="sk:-ml-3">
          <span className="sk:text-fg-secondary">Lots</span>
          <b>{lots.length}</b>
          <InfoIcon size={14} aria-hidden />
        </Button>
      }
    >
      <p className="sk:m-0 sk:mb-2 sk:text-dense">
        This Alias is present in following {lots.length} Lots
      </p>
      <div className="sk:max-h-[50vh] sk:overflow-y-auto">
        <Table aria-label="Lots">
          <TableHeader>
            <Column isRowHeader>Lot Number</Column>
            <Column>Expiry Date</Column>
            <Column>Available Quantity</Column>
            <Column>Is Pallet</Column>
          </TableHeader>
          <TableBody>
            {lots.map((lot, index) => (
              <Row key={`${lot.lotNumber ?? 'none'}-${index}`}>
                <Cell>
                  {lot.lotNumber ?? (
                    <span className="sk:text-fg-tertiary">No Lot Number</span>
                  )}
                </Cell>
                <Cell>
                  {lot.expiryDate
                    ? DateUtility.formatDate(
                        lot.expiryDate,
                        DateFormat.barChartMonth,
                      )
                    : '-'}
                </Cell>
                <Cell>
                  {lot.available}{' '}
                  <span className="sk:text-fg-tertiary">Units</span>
                </Cell>
                <Cell>
                  {lot.isPallet && (
                    <CheckIcon className="sk:text-success" aria-label="Yes" />
                  )}
                </Cell>
              </Row>
            ))}
          </TableBody>
        </Table>
      </div>
    </Popover>
  );
}
